import { SET_PAGE_INDEX, SET_ROW_COUNT } from './types';

export const setTableIndex = data => {
    return {
        type: SET_PAGE_INDEX,
        payload: data
    };
};

export const setRowCount = data => {
    return {
        type: SET_ROW_COUNT,
        payload: data
    };
};
